export default __webpack_public_path__ + "static/media/bank_transfer.60beae10.png";